/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);


const exportUsers = Vue.resource('admin/reports{/id}');


// example usage: #todo
// import subject from './resources/subject'
// subject.query({}).then((res) => {
//   console.log(res)
// }, (res) => {
//   console.log(res)
// })




export default exportUsers;



// WEBPACK FOOTER //
// ./src/resources/userActivityReport.js